"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusTransition = void 0;
class StatusTransition {
    isAllowed(from, to, userPermissions) {
        for (const transition of this.allowedTransitions) {
            if (transition.from.includes(from) && transition.to.includes(to)) {
                return transition.permissions
                    ? userPermissions.length &&
                        userPermissions.some((p) => transition.permissions.has(p))
                    : true;
            }
        }
        return false;
    }
}
exports.StatusTransition = StatusTransition;
//# sourceMappingURL=base.js.map